<template>
  <div class="div-container">
    <div v-if="loading" class="modal-loading">
        <b-spinner
          v-if="loading"
          label="Spinning"
          variant="primary"
          class="modal-loading-spinning"
        ></b-spinner>
      </div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <!-- Tenant -->
        <validation-provider
          #default="validationContext"
          name="Tenant"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$tc('tenants.title', 2)"
            label-for="id_tenant"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemData.tenant"
              data-cy="automatest-wizard-tenant-select"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="filterTenantsArray"
              :clearable="false"
              :reduce="(val) => val.value"
              input-id="id_tenant"
              multiple
              cacheOptions="{false}"
            />
            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <!-- Tipos de alarma -->
        <multiple-alarms-select
          :itemData="{ type_alarm: itemData.type_alarm ? itemData.type_alarm : [] }"
          :options="typeAlarmOptions"
          @update:itemData="itemData.type_alarm = $event.type_alarm"
        />

        <!-- id_type_alarm -->
        <!-- <validation-provider
          #default="validationContext"
          :name="$tc('types_alarms.title', 2)"
          rules="required"
        >
          <b-form-group
            class="text-capitalize"
            :label="$tc('types_alarms.title', 2)"
            label-for="id_type_alarm"
            :state="getValidationState(validationContext)"
          >
            <v-select
              v-model="itemData.type_alarm"
              data-cy="automatest-wizard-type-alarm-select"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="typeAlarmOptions"
              :clearable="false"
              :reduce="(val) => val.value"
              input-id="id_type_alarm"
              multiple
            />
            <b-form-invalid-feedback
              :state="getValidationState(validationContext)"
            >
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider> -->
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import { ref, onMounted, watch, nextTick } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { required, alphaNum, email, positive, required_if } from "@validations";
import store from "@/store";
import MultipleAlarmsSelect from "@/components/Alarm/MultipleAlarmsSelect";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    BFormRadio,
    MultipleAlarmsSelect,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
    },
    typeAlarmOptions: {
      type: Array,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
      required_if,
    };
  },

  setup(props, { emit }) {
    const isUpdatingFromProps = ref(false);
    const filterTenantsArray = ref([]);
    const sharedTenantsArray = ref([]);
    const loading = ref(false)

    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    onMounted(() => {
    loading.value = true;
    store
        .dispatch("tenant/getAll")
        .then(() => {
            filterTenantsArray.value = store.getters["tenant/getSelectedItems"];
            if (!props.isAdd && props.propItemData.sharedTenants) { //not show sharedtenants
                sharedTenantsArray.value = props.propItemData.sharedTenants.map(item => item.id);

                filterTenantsArray.value = filterTenantsArray.value.filter(
                    tenant => !sharedTenantsArray.value.includes(tenant.value)
                );
            }
            loading.value = false;
        })
        .catch((error) => {
            console.log("error", error);
            loading.value = false;
        });
    });

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    // Sync changes propItemData with itemData
    watch(
      () => props.propItemData,
      (newValue) => {
        isUpdatingFromProps.value = true;
        itemData.value = { ...newValue };
      },
      { deep: true }
    );

    // Observe changes in itemData.tenant
    watch(
      () => itemData.value.tenant,
      (newValue, oldValue) => {
        if (newValue !== oldValue && !isUpdatingFromProps.value) {
          emit("update:itemData", { tenant: newValue });
        }
        nextTick(() => {
          isUpdatingFromProps.value = false;
        });
      }
    );

    //Observe changes in itemData.type_alarm
    watch(
      () => itemData.value.type_alarm,
      (newValue, oldValue) => {
        if (newValue !== oldValue && !isUpdatingFromProps.value) {
          emit("update:itemData", { type_alarm: newValue });
        }
        nextTick(() => {
          isUpdatingFromProps.value = false;
        });
      }
    );

    return {
      itemData,
      loading,
      refFormObserver,
      getValidationState,
      filterTenantsArray,
      validateStep,
      isUpdatingFromProps,
    };
  },
};
</script>

<style lang="scss">
.vs--disabled .vs__selected {
  background-color: #1b3d5e !important;
}
</style>
